export class ExportTransactionsRequest {
  eventId: number;
  storeId: number;
  tenantUUID: string;
}
